import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: '#FFF',
  [theme.breakpoints.up('md')]: {
    overflowY: 'scroll',
  },
  [theme.breakpoints.up('lg')]: {
    overflowY: 'auto',
    height: '100vh',
  },
}));

export default StyledBox;
